<script setup lang="ts">
import { PopoverTrigger } from 'radix-vue'
</script>

<template>
  <PopoverTrigger>
    <slot />
  </PopoverTrigger>
</template>
